import React from "react";
class Roadmap extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <iframe
        src="https://app.loopedin.io/destinydao#/roadmap"
        style={{
          flexGrow: "1",
          border: "none",
          margin: "0",
          padding: "0",
          marginTop: "-80px",
          borderRadius: "10px",
          height: "1900px",
        }}
      ></iframe>
    );
  }
}

Roadmap.displayName = "Roadmap";

export default Roadmap;
